import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty } from 'lodash';
import * as layerOps from '../../api/Layers/layer-operations';
import buildDeckTileLayer from './buildDeckTileLayer';
import buildDeckGeoJSONLayer from './buildDeckGeoJSONLayer';
// import buildDeckWMSLayer from './buildDeckWMSLayer';
import buildDeckGeoImageLayer from './buildDeckGeoImageLayer';
import { styleFetchOne } from '../../api/Styles/style-methods-client';
import getDefaultStyle from '../get-default-style';

const addLayerToDeckViewer = async ({ layer, FindLayerVisible, activeLayers }) => {
  let newLayerToDraw = '';
  const style = !isEmpty(layer.styleValue)
    ? layer.styleValue
    : (await styleFetchOne(layerOps.getStyleId(layer))) || getDefaultStyle(layer);
  try {
    switch (true) {
      case layerOps.isTileServer(layer):
        newLayerToDraw = buildDeckTileLayer({ layer, FindLayerVisible, activeLayers });
        break;
      case layerOps.isTMS(layer):
        newLayerToDraw = buildDeckTileLayer({ layer, FindLayerVisible, activeLayers });
        break;
      case layerOps.isWMS(layer):
        // No es posible hasta actualizar a la version 8.9 de Deck
        // newLayerToDraw = buildDeckWMSLayer({ layer, FindLayerVisible, activeLayers });
        break;
      case layerOps.isWMTS(layer):
        // newLayerToDraw = buildWMTSLayer({ layer, style, zIndex });
        break;
      case layerOps.isGeoImage(layer):
        newLayerToDraw = buildDeckGeoImageLayer({ layer, FindLayerVisible, activeLayers });
        break;
      case layerOps.isGeoTiff(layer):
        // newLayerToDraw = await buildGeoTiffLayer({ layer, style, zIndex, isPartOfMap: true });
        break;
      case layerOps.isGeoJSONApiBased(layer):
        newLayerToDraw = await buildDeckGeoJSONLayer({
          layer,
          FindLayerVisible,
          activeLayers,
          style
        });
        break;
      case layerOps.isGeoJSONVT(layer):
        // newLayerToDraw = await buildGeoJSONVTLayer({ layer, style, zIndex, isPartOfMap: true });
        break;
      case layerOps.isIndoor(layer):
        // newLayerToDraw = await buildIndoorGeoJSONLayer({
        //   layer,
        //   style,
        //   zIndex,
        //   leafletMap,
        //   isPartOfMap: true,
        //   zoomLevel
        // });
        break;
      case layerOps.isMapBox(layer):
        // newLayerToDraw = await buildMapBoxLayer({ layer, style, zIndex, isPartOfMap: true });
        break;
      case layerOps.isMapBoxGL(layer):
        // newLayerToDraw = await buildMapBoxGLLayer({ layer, style, zIndex });
        break;
      case layerOps.isRealTime(layer):
      case layerOps.isAnnotationsRealTime(layer):
        // newLayerToDraw = await buildRealTimeLayer({ layer, style, zIndex, isPartOfMap: true });
        break;
      case layerOps.isTopoJSON(layer):
        // newLayerToDraw = await buildTopoJSONLayer({ layer, style, zIndex, isPartOfMap: true });
        break;
      default:
        Bert.alert('Wrong Layer data', 'danger');
        break;
    }
  } catch (error) {
    console.error(error);
  }
  return newLayerToDraw;
};

addLayerToDeckViewer.propTypes = {};

export default addLayerToDeckViewer;
